import { useQuery } from "@apollo/client";
import React, { useContext } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import Flex from "../../components/common/Flex";
import { AppContext } from "../../context/AppContext";
import PATH from "../../routes/RoutePath";
import QUERY from "../../utils/service/query";

const MyAccount = () => {
	const { setUser } = useContext(AppContext);
	const { data } = useQuery(QUERY.ACCOUNT.GET_MY_ACCOUNT);

	return (
		<Card className="">
			<Card.Header>
				<h5>My Account</h5>
			</Card.Header>
			<Card.Body className="bg-light">
				<Row>
					<Col lg={4}>
						<h3>
							{(data?.getAdminProfile?.userProfile?.firstName ?? "") +
								" " +
								(data?.getAdminProfile?.userProfile?.lastName ?? "")}
						</h3>
					</Col>
					<Col lg={4}>
						<p>{data?.getAdminProfile?.email || ""}</p>
					</Col>
					<Col lg={4}>
						<Flex justifyContent={"end"}>
							<Link to={PATH.ACCOUNT.EDIT_MY_ACCOUNT}>
								<Button className="mx-2">EDIT</Button>
							</Link>
							<Button
								variant="outline-danger"
								onClick={() => {
									window.localStorage.removeItem("token");
									window.localStorage.removeItem("user");
									window.localStorage.setItem("isUserLoggedIn", "false");
									setUser({
										user: {},
										isUserLoggedIn: false,
										token: "",
										isInitialized: true,
									});
								}}>
								LOGOUT
							</Button>
						</Flex>
					</Col>
				</Row>
			</Card.Body>
		</Card>
	);
};

export default MyAccount;
